import contactData from './generated/contact';
import toursData from './data/tours';
import type { Contact, Tour, TourPolicy } from '@supay-expeditions/model';

export type {
  Contact,
  Person,
  Tour,
  TourDetails,
  TourPolicy,
  TourRoad,
  ToursFile,
} from '@supay-expeditions/model';

export const contact: Contact = contactData;
export const tours: readonly Tour[] = toursData.tours;
export const tourPolicy: TourPolicy = {
  languages: toursData.languages,
  cancellation: toursData.cancellation,
};
